<template>
    <div class="payment">
        <div class="search">
            <el-row :gutter="10">
                <el-col :span="3">
                    <el-input placeholder="请输入姓名或电话号码查找" v-model.trim="search" clearable></el-input>
                </el-col>
                <el-col :span="1">
                    <el-button type="primary" :disabled="tableLoading" :loading="tableLoading" icon="el-icon-search" @click="getList">{{ tableLoading?'搜索中':'搜索' }}</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="table">
            <UseTable 
                id="PaymentManagement"
                :distributionIsShow="false"
                :empty-text="emptyText"
                :header-data="headerData"
                :table-data="tableData"
                :pagination="pagination"
                :table-loading="tableLoading"
                :element-loading-text="loadingText"
                componentTableId="PaymentManagement"
                :table-height="780"
                @handleCard="openDialog"
                >
                    <template v-slot:productListcustom="scope">
                        <div style="text-overflow: ellipsis;overflow: hidden;" @click="openDialog(scope.scope, 'productList')">
                            <span class="hand blue" v-if="scope.scope.productList.length === 1">{{ scope.scope.productList[0].productTitle }}</span>
                            <span class="hand blue" v-if="scope.scope.productList.length > 1">共{{ scope.scope.productList.length }}个产品</span>
                            <span v-if="!scope.scope.productList.length" class="gray">未设置</span>
                        </div>
                    </template>
                    <template v-slot:pricecustom="scope">
                        <div v-html="scope.scope.price"></div>
                    </template>
                    <template v-slot:installmentInfocustom="scope">
                        <div v-html="scope.scope.price"></div>
                    </template>
                    <template v-slot:remarkObjcustom="scope">
                        <span>
                        <b @click="clickRemark(scope.scope.remarkObj, scope.scope)" style="cursor: pointer; font-size: 12px"
                            class="blue">{{ remarkData(scope.scope.remarkObj) }}</b>
                        </span>
                    </template>
                    <template v-slot:orderStateNamecustom="scope">
                        <span>
                        <el-tag :class="tagColor(scope.scope.orderState)">{{ scope.scope.orderStateName }}</el-tag>
                        </span>
                    </template>
                    <template v-slot:codecustom="scope">
                        <el-tag
                        v-if="(scope.scope.orderState == 1 || scope.scope.orderState == 3) && scope.scope.orderType != 6 && scope.scope.orderType != 5 && scope.scope.payMoney > 0"
                        class="blue hand" @click="checkCode(scope.scope)">查看二维码</el-tag>
                        <el-tag v-else type="info">不符合</el-tag>
                    </template>
            </UseTable>
            <!-- 底部工具 -->
            <PaginationTool :pagination="pagination" :is-loading="tableLoading"
            @change-pagination="changePagination"></PaginationTool>
        </div>


        <!--产品列表弹窗-->
        <el-dialog title="订单产品列表" ref="productDialog" :visible.sync="productDialogVisible" v-if="productDialogVisible"
        :close-on-click-modal="false" @close="productDialogVisible = false" heigth="300px" v-dialogDrag top="18vh"
        width="761px">
        <el-table :data="gridData" id="zengpin" max-height="500px" style="width: 100%" :default-expand-all="true"
            :header-cell-style="{ background: '#f5f7fa' }" border class="bigTable">
            <el-table-column type="expand" :show-overflow-tooltip="true">
                <template slot-scope="props">
                    <el-table :data="props.row.givingProductList" :show-header="false" :default-expand-all="true"
                    empty-text="没有赠送产品" style="width: 100%; margin: -21px 0 0 1px;" border>
                    <el-table-column prop="productTitle" align="left" width="370" :show-overflow-tooltip="true"
                        label="产品标题"></el-table-column>
                    <el-table-column prop="productTypeName" align="center" :show-overflow-tooltip="true" width="90"
                        label="产品类别"></el-table-column>
                    <el-table-column prop="discountMoney" align="left"  :show-overflow-tooltip="true" label="费用积分">
                        <template slot-scope="scope">
                        <div v-html="$constGlobal.formatProductMonth(
                            scope.row.integral,
                            scope.row.originalMoney,
                            scope.row.discountMoney
                        )
                            "></div>
                        </template>
                    </el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column prop="productTitle" align="left" :show-overflow-tooltip="true" width="370"
            label="产品标题"></el-table-column>
            <el-table-column prop="productTypeName" align="center" width="90" :show-overflow-tooltip="true"
            label="产品类别"></el-table-column>
            <el-table-column prop="discountMoney" align="left"  :show-overflow-tooltip="true" label="费用积分">
                <template slot-scope="scope">
                    <div v-html="$constGlobal.formatProductMonth(
                    scope.row.integral,
                    scope.row.originalMoney,
                    scope.row.discountMoney
                    )
                    "></div>
                </template>
            </el-table-column>
        </el-table>
        </el-dialog>
        <el-dialog title="查看分期详情" ref="installmentDialog" :visible.sync="installmentVisible" v-if="installmentVisible"
      :close-on-click-modal="false" @close="installmentVisible = false" heigth="300px" width="650px" v-dialogDrag
      top="18vh">
      <el-table :data="installmentData" style="width: 100%" border>
        <el-table-column prop="installmentNumber" align="center" label="期数编号"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="money" align="center" label="金额" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="payStateName" align="center" label="支付状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="payTime" width="180" align="center" label="支付时间"
          :show-overflow-tooltip="true"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="remarkTitle" :visible.sync="remarkDialogVisible" v-if="remarkDialogVisible" width="900px"
      v-dialogDrag top="18vh" class="Remark" :close-on-click-modal="false" :before-close="beforeClose">
      <RemarkList :list="RemarkList" style="width: 100%" :order="true" @close-dialog="beforeClose"></RemarkList>
    </el-dialog>
    <el-dialog :title="code_title" :visible.sync="dialogVisibleCode" v-if="dialogVisibleCode" width="700px"
      :close-on-click-modal="false" v-dialogDrag top="15vh">
      <div class="abow_dialog_new">
        <img class="qr_code" :src="order_code" alt="支付二维码">
      </div>
    </el-dialog>
    </div>
</template>

<script>
import UseTable from '@/components/StudentList.vue'
import PaginationTool from "components/PaginationTool";
import RemarkList from "components/RemarkList.vue";
import { getOrderList, GenerateQrCode } from "network/orderPayconfig";
import {
  dateformat,
  getAdminName,
  timeFormatNew,
  isNull,
  addClassName
} from "common/utils";
export default {
    name: 'HuihangAdminPcIndex',
    components: {
        UseTable,
        PaginationTool,
        RemarkList
    },
    data() {
        return {
            search: '',
            emptyText: '暂无数据',
            tableLoading: false,
            loadingText: "loading...", //加载状态提示文本
            headerData: [
                {
                    label: '学员姓名',
                    align: 'left',
                    prop: 'studentName',
                    fixed: true,
                    width: "120",
                    noTooltip: true,
                    noSetText: "未设置"
                },
                {
                    label: '联系电话',
                    align: 'center',
                    prop: 'telNumber',
                    width: "150",
                    noTooltip: true,
                    noSetText: "未设置"
                },
                {
                    label: '微信号',
                    align: 'center',
                    prop: 'weiXinNumber',
                    width: "150",
                    noTooltip: true,
                    noSetText: "未设置"
                },
                {
                    label: '所属招生老师',
                    align: 'center',
                    width: "150",
                    prop: 'businessName',
                    noTooltip: true,
                    noSetText: "未设置",
                },
                {
                    label: '订单产品',
                    align: "left",
                    width: "200",
                    prop: 'productList',
                    // table: true,
                    noTooltip: true,
                    noSetText: "未设置",
                    custom: true,
                },
                {
                    label: '订单类型',
                    align: 'center',
                    width: "150",
                    prop: 'orderTypeName',
                    noTooltip: true,
                    noSetText: "未设置",
                    tipContent: true,
                    content: "<div style='font-size:16px'>订单类型汇总说明</div>1 普通订单--是指普通付费产品订单，可以使用优惠券，但不能团报、分期以及使用积分支<br/>付等方式<br/>2 分期订单--分多期支付的订单：分期订单设置由老师在后台订单列表页针对[待支付状态的<br/>普通订单]设置分期后转为分期订单<br/>3 开团订单--团报课程产品团长开团的订单：开团方式只能通过课程团报产品页开团下订单<br/>4 参团订单--团报课程产品团员参团的订单：参团方式可以通过团分享参团也可以通过团报<br/>课程产品页选择团参团<br/>5 积分订单--使用积分购买的产品订单，积分订单不与普通付费订单共存<br/>6 免费订单-免费无需付款或消耗积分的订单<br/>"
                },
                {
                    label: '订单状态',
                    align: 'center',
                    width: "150",
                     prop: 'orderStateName',
                     noTooltip: true,
                    noSetText: "未设置",
                    custom: true,
                    tipContent: true,
                    content: "<div style='font-size:16px'>订单状态汇总说明</div>1 待支付-产品已下单但未付款的订单状态<br/>2 拼团中--针对开团或参团订单已支付，但所开团或所参团的团状态还处于拼团中，并未成<br/>团也未拼团超时所展示的状态<br/>3 部分付款--针对分期订单所分期期数未全部付款时所展示的状态<br/>4 订单完成--用户订单已全部付款；如果是团报(开团或参团)订单，说明用户已支付且团已<br/>5 拼团成功；如果是分期订单，说明订单下所有分期期数均已支付；<br/>6 订单部分退费-已支付的课程类普通订单，后台手动操作退费，退费金额小于订单已支付金<br/>额时，订单状态为部分退费状态<br/>7 订单全退费--已支付的课程类普通订单，后台手动操作退费，退费金额等于订单已支付金<br/>额时，订单状态为全退费状态<br/>8 交易关闭--待支付订单过期失效或开团/参团订单到拼团截止时间未支付，系统自动将订单<br/>状态切换为交易关闭状态"
                },
                {
                    label: '支付二维码',
                    align: 'center',
                    width: "130",
                    prop: 'code',
                    custom: true,
                },
                {
                    label: '订单金额',
                    align: 'center',
                     prop: 'payMoney',
                    //  noTooltip: true,
                    // noSetText: "未设置",
                    unit: true,
                    unitText: '元',
                    width: "130",
                },
                {
                    label: '价格费用',
                    align: 'left',
                    width: "350",
                     prop: 'price',
                     custom: true,
                     noTooltip: true,
                    noSetText: "未设置"
                },
                {
                    label: '分期设置',
                    align: 'center',
                     prop: 'installmentInfo',
                     width: "100",
                     table: true,
                     noTooltip: true,
                    noSetText: "未设置"
                },
                {
                    label: '创建时间',
                    align: 'center',
                     prop: 'createTime',
                     width: "170",
                     noTooltip: true,
                    noSetText: "未设置"
                },
                {
                    label: '支付时间',
                    align: 'center',
                    width: "170",
                     prop: 'payTime',
                     noTooltip: true,
                    noSetText: "未设置"
                },
                {
                    label: '订单备注',
                    align: 'center',
                     prop: 'remarkObj',
                     fixed: "right",
                     width: "340",
                     noTooltip: true,
                     custom: true,
                    noSetText: "未设置"
                },
            ],
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 20,
                total: 0,
            },
            gridData: [],
            installmentData: [],
            RemarkList: [],
            productDialogVisible: false,
            installmentVisible: false,
            remarkDialogVisible: false,
            order_code: '',
            code_title: '',
            dialogVisibleCode: false
        };
    },
    computed: {
        remarkData() {
            return val => {
                return val.join(",");
            }
        },
        tagColor() {
            return function (value) {
                var rule = [
                { class: "student_tag_yellow", value: [1] },
                { class: "student_tag_blue", value: [2, 3] },
                { class: "student_tag_green", value: [4] },
                { class: "student_tag_gray", value: [5, 6] },
                { class: "student_tag_red", value: [7] }
                ];
                return addClassName(value, rule);
            };
        },
    },
    created() {
      setTimeout(() => {
        if(sessionStorage?.getItem("AdminToken")){
            let adminInfo = sessionStorage?.getItem("AdminToken")
        ? JSON.parse(sessionStorage?.getItem("AdminToken"))
        : [];
      let expiresTime = adminInfo?.expires_in + new Date() / 1000;
      const token = {
        AccessToken: adminInfo?.access_token,
        AccessExpiresIn: expiresTime,
        RefreshToken: adminInfo?.refresh_token,
      };
      if(token) this.$store.commit("updateToken", token); 
      sessionStorage.removeItem("AdminToken"); //移除
        }
    }, 2000);
    },

    methods: {
        beforeClose() {
            this.RemarkList = [];
            this.remarkDialogVisible = false;
        },
        async checkCode(item) {
            this.tableLoading = true
            const {data:res} = await GenerateQrCode({orderId:item.id})
            this.tableLoading = false
            if (res.code == 1) {
                this.order_code = res.result
                this.code_title = `学员[${item.studentName ? item.studentName : item.studentId}]的支付二维码`
                this.dialogVisibleCode = true
            } else {
                this.$alert(res.message)
            }
        },
        clickRemark(val, data) {
            this.remarkTitle = `学员[${data.studentName}]的订单备注信息`;
            var data = {
                contents: ""
            };
            var RemarkList = [];
            val.map(item => {
                data.contents = item;
                RemarkList.push(JSON.parse(JSON.stringify(data)));
            });
            this.RemarkList = RemarkList.reverse();
            this.remarkDialogVisible = true;
        },
        openDialog(res, prop) { 
            if (prop === "installmentInfo") {
                const installmentList = res.orderInstallments;
                if (installmentList.length > 0) {
                let installmentData = [];
                installmentList.map(org =>
                    installmentData.push({
                    installmentNumber: org.installmentNumber,
                    money: org.money,
                    payStateName: org.payStateName,
                    payTime: org.payTime
                    })
                );

                this.installmentData = installmentData;
                this.installmentVisible = true;
                }
            }
            if (prop === "productList") {
                const productList = res.productList;
                if (productList.length > 0) {
                let gridData = [];
                productList.map(org => {
                    var givingProductList = [];
                    if (org.givingProductList && org.givingProductList.length > 0) {
                    org.givingProductList.map(item =>
                        givingProductList.push({
                        productTitle: item.title,
                        originalMoney: item.originalMoney,
                        discountMoney: item.discountMoney,
                        productTypeName: item.productTypeName,
                        integral: item.integral
                        })
                    );
                    }
                    gridData.push({
                        productTitle: org.productTitle,
                        originalMoney: org.originalMoney,
                        discountMoney: org.discountMoney,
                        productTypeName: org.productTypeName,
                        integral: org.integral,
                        givingProductList: givingProductList
                    });
                });
                    this.gridData = gridData;
                    this.productDialogVisible = true;
                }
            }
        },
        changePagination() {
            this.getList();
        },
        async getList () {
          if (this.search) {
            this.tableLoading = true
            const newStr = this.search.replace(/\s+/g, "")
            const params = {
              pageIndex: this.pagination.currentPage,
              pageSize: this.pagination.pageSize,
              keyword: newStr,
            }
            const {data:res} = await getOrderList(params)
            this.tableLoading = false
            if (!res.code) {
              this.$alert(res.message, '提示', {
                confirmButtonText: '确定',
              })
              return
            }
            this.dataBind(res, this.pagination);
          } else {
            this.$message.error('请输入要搜索的姓名或电话号码');
            this.tableData = []
            this.pagination.total = 0
            this.pagination.currentPage = 1
          }
        },
        dataBind(result, pagination) {
            this.tableLoading = false;
            if (result) {
                if (result.code === 1) {
                if (pagination.currentPage === 1) {
                    this.pagination.total = result.totalCount;
                }
                var rows = result.result;
                if (rows && rows.length > 0) {
                    for (let item of rows) {
                    item.IsGroup =
                        item.groupHeadId !== "00000000-0000-0000-0000-000000000000"
                        ? "是"
                        : "否";
                    // item.price = item.orderType == 5
                    //     ? item.payMoney + "积分"
                    //     : item.originalMoney <= item.payMoney
                    //       ? `现价格${item.payMoney}元`
                    //       : `原价格${item.originalMoney}元/实付价${item.payMoney}元`;
                    item.price = item.orderType == 5
                        ? item.payMoney + "积分"
                        // : `原价格${item.originalMoney}元/实付价${item.payMoney}元`;
                        : this.computedPrice(item.actualMoney, item.arrearsMoney, item.originalMoney, item.discountMoney)


                    //  `实付${item.payMoney}元/欠xx元/原价${item.originalMoney}元/现价${item.discountMoney}元`;
                    if (item.orderType == 6) item.price = `<span class="gray">免费</span>`;
                    item.installmentInfo =
                        item.installmentCount > 0
                        ? `分${item.installmentCount}期`
                        : null;
                    var refundMoney =
                        item.refundMoney > 0 ? `退${item.refundMoney}元` : "";
                    var reduceMoney =
                        item.reduceMoney > 0 ? `减${item.reduceMoney}元` : "";
                    var refundReduceMoney = reduceMoney + refundMoney;
                    item.refundReduceMoney =
                        refundReduceMoney.length > 0 ? refundReduceMoney : null;
                    let productNames = [];
                    if (item.productList && item.productList.length > 0) {
                        item.productList.map(org => {
                        productNames.push(org.productTitle);
                        });
                    }

                    item.productNames =
                        productNames.length == 0
                        ? "未设置"
                        : productNames.length == 1
                            ? productNames[0]
                            : `共${productNames.length}个产品`;
                    }
                }
                this.tableData = rows;
                this.emptyText = this.tableData ? "" : "暂无数据";
                } else {
                this.emptyText = "暂无数据";
                this.$alert(result.message);
                }
            }
        },
        computedPrice(payMoney, arrearsMoney, originalMoney, discountMoney) {
            let renderHtml = ''
            renderHtml += `<span>实付${payMoney}元/</span>`
            if (arrearsMoney > 0) {
                renderHtml += `<span class="red">欠</span><span>${arrearsMoney}元/</span>`
            }
            if (originalMoney) {
                renderHtml += `<span>原价${originalMoney}元/</span>`
            }
            if (discountMoney) {
                renderHtml += `<span>现价${discountMoney}元</span>`
            }
            return renderHtml
        },
    },
};
</script>

<style lang="scss" scoped>
.payment {
    --ThemeColor: #409eff;
    width: 100%;
    height: 100vh;
    padding: 20px;
    .el-button--primary {
        background-color: var(--ThemeColor);
    }
    .table {
        height: calc(100% - 80px);
        overflow: auto;
        margin-top: 20px;
        
    }
    .bigTable {
        overflow: hidden !important;
    }
    ::v-deep .el-table__expanded-cell {
        padding: 20px 0 0 46px;
    }
}
.el-input-group_prepend {
  width: 30px;
  border: 1px solid red;
}

.read {
  color: red;
  margin-left: 80px;
}

.enrollVisible-btn {
  text-align: left;
  margin-left: 100px;
  display: inline-block;
  margin-top: 20px;
}

.abow_dialog {
  overflow: hidden;
}

.study_detail_style {
  height: 500px;
  overflow: auto;
}

.input-w {
  width: 220px;
}

.input-d {
  width: 310px;
}

.over_hide {
  overflow: hidden;
  text-overflow: ellipsis;
}

.live_price {
  margin-right: 20px;
}

.student-choose::v-deep .el-button {
  width: 220px;
}



.textarea-w {
  width: 572px;
}

.hover-sty {
  color: #c0c0c0;
  cursor: pointer;
}

.hover-sty:hover {
  color: #409eff;
}

.remark-details {
  padding: 20px 20px 0;
}

.remark-details li {
  margin-bottom: 20px;
  font-size: 14px;
}

.remark-style {
  white-space: pre-line !important;
}

.tool_class {
  width: 250px;
  line-height: 150%;
}

/* .student_dialog::v-deep.el-table__body-wrapper{
  padding: 20px;
} */
.abow_dialog ::v-deep .el-table__body-wrapper {
  height: 200px;
  overflow: aotu;
  border: 1px solid rgb(235, 238, 245);
}

.Remark ::v-deep .el-table__body {
  width: auto !important;
}

::v-deep .el-dialog__footer {
  text-align: left;
  margin-left: 90px;
}

.btn-area {
  margin-top: 48px;
}

.btn-area ::v-deep .el-button {
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}

.post_from ::v-deep .el-from {
  margin-bottom: 0;
}

.inline {
  width: 50%;
  display: inline-block;
  margin-right: 10px;
}

.inline ::v-deep .el-form-item__content {
  width: 69%;
  display: inline-block;
  margin-left: 0 !important;
}

::v-deep .el-form {
  margin-bottom: 0px;
}

.inline ::v-deep .el-tooltip {
  width: 90%;
}

.postage-money {
  width: 46%;
  display: inline-block;
}

.postage-money ::v-deep .el-form-item__label {
  width: 70px !important;
  text-align: left;
}

.postage-money ::v-deep .el-form-item__content {
  margin-left: 70px !important;
}

::v-deep .el-input__inner {
  line-height: 1px !important;
}

/* 统计数据 */
.payment .host-list-top {
  margin: 0 0 10px 0;
}

.payment ::v-deep .comTopRight {
  top: 20px;
}

.payment ::v-deep .descriptions-label {
  text-align: center !important;
  color: #606266 !important;
  font-weight: 600 !important;
  width: 110px;
}

.payment ::v-deep .descriptions-content {
  text-align: center !important;
  color: #409eff;
  width: 90px;
  padding: 0 10px !important;
}

.money_red {
  color: #fd5252;
}

.abow_dialog_new {
  display: flex;
}

.qr_code {
  width: 400px;
  height: 615px;
  margin: 0 auto;
}

.transfer_form {
  width: 100%;
  height: 500px;
  overflow: auto;
}

.dialog-title {
  font-size: 18px;
}

.demo_ruleForm_direct {
  height: 510px;
  overflow-y: scroll;
}

.order_reduction {
  height: 500px;
  overflow-y: auto;
}

.margin-top {
  margin-top: 15px;
}

::v-deep.el-table__fixed-body-wrapper {
  top: 58px !important;
}

.pr-5 {
  padding-right: 5px;
  box-sizing: border-box;
}

.padding-0 {
  padding: 0;
}

.color-transparent {
  color: transparent;
}

.cell-item {
  display: flex;
  align-items: center;
}
</style>